import React, { useEffect } from "react";
import styled from "styled-components"
import { useParams } from "react-router-dom";

import Layout from "../components/layout"
import Container from "../components/container"
import PageHeader from "../components/header-page"

import ReactGA from "react-ga4";
ReactGA.initialize("G-THHYTX4Y9V");

function FestivalPage(props) {
  let { name } = useParams();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/festival", title: "Festival"});
  }, []);

  return (
    <Layout page="festival" title="Festival">
      <Container>
        <PageHeader>Festival</PageHeader>
        {name}
      </Container>
    </Layout>
  );
}

export default FestivalPage;